import ActionSection from '@helios/ActionSection'
import ButtonLink from '@helios/ButtonLink'

import useCampus from '@/hooks/useCampus.ts'
import {activeTerm, formatTermDate} from '@/utils/campusTerms'
import styles from './ApplyNow.module.scss'

// The apply band (Phase 5 PR 5.2, Q10 A): ActionSection's conversion variant
// with the same heading, copy and CTA; no eyebrow or facts (new copy is
// Phase 6). A section of its own on the section rhythm: P above it, P inside
// the brand band, and a band directly before it (a subtle contact band)
// abuts it. `titlePeriod` ends the title with a full stop, the redesign's
// wording ("Apply now for October 2026."), which /professors takes (Phase 6
// p09, Alex 2026-10-06); every other page keeps the title as it is.
function ApplyNow({message = '', titlePeriod = false}) {
  const {termsQuery} = useCampus()
  const term = activeTerm(termsQuery.data)

  return (
    <ActionSection
      actions={
        <ButtonLink href="/admissions-application" arrow>
          Apply now
        </ButtonLink>
      }
      title={
        <>
          Apply now for{' '}
          {term
            ? formatTermDate(term.termStartsAt, {
                month: 'long',
                year: 'numeric',
              })
            : 'the next term'}
          {titlePeriod && '.'}
        </>
      }
      titleAs="h2"
      variant="conversion"
    >
      {term && (
        <h3 className={styles.subheading}>
          Classes start{' '}
          {formatTermDate(term.termStartsAt, {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          })}
        </h3>
      )}
      <p>
        {message ||
          'If you’re savvy, ambitious, and looking to knock out the first two years of college while learning from some of the best professors in the country, we should talk.'}
      </p>
    </ActionSection>
  )
}

export default ApplyNow
